/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_Other_RequiredInputs */

const en_task_requested_documents_other_required = /** @type {(inputs: Task_Requested_Documents_Other_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe every "other" document you are requesting.`)
};

const pt_br2_task_requested_documents_other_required = /** @type {(inputs: Task_Requested_Documents_Other_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva cada documento "outro" solicitado.`)
};

/**
* | output |
* | --- |
* | "Describe every \"other\" document you are requesting." |
*
* @param {Task_Requested_Documents_Other_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_other_required = /** @type {((inputs?: Task_Requested_Documents_Other_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_Other_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_other_required(inputs)
	return pt_br2_task_requested_documents_other_required(inputs)
});